module.exports = __webpack_public_path__ + "img/_driving.4278b036.svg";